
export default {
  name: "",
  props: {
    list: {
      type: Array,
      default: []
    },
    
  },
  data() {
    return {
      tabIndex: -1,
    }
  },
  methods: {
    selection(item, index) {
      if (index == 0) { return; }
      this.tabIndex = index;
      this.$emit('selection', item);
    }
  }
}
